export const USER_FINGERPRINT = 'user-fingerprint';
export const SESSION_FINGERPRINT = 'session-fingerprint';
